import axiosInstance from './AxiosInstance';

const BASE = 'invoice-download-jobs';

export const createInvoiceDownloadJob = (data) =>
  axiosInstance.post(`${BASE}/create`, data);

export const getInvoiceDownloadJobs = (params) =>
  axiosInstance.get(`${BASE}/list`, { params });

export const regenerateInvoiceSheet = (id) =>
  axiosInstance.post(`${BASE}/regenerate-sheet/${id}`);
